import { Observable, Subscription } from 'rxjs';
import { DropdownQuestion } from './question-dropdown';
import { Agent } from 'core/models/agent';
/*

Sample:

new AgentsQuestion({
  label: 'nouns.cs',
  agents: this.agentsCache.getAgents(this.agentsCache.ROLES.CS),
  value: [],
}),

*/
export class AgentsQuestion extends DropdownQuestion {
  controlType = 'agent';
  agents: any[];
  agentsObservable: Observable<Agent[]>;
  agentsIds: string[];

  agentsSubscription: Subscription;

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
    this.setAgents(options['agents'] || []);
    this.agentsObservable = options['agentsObservable'];
    this.multiple = true;
    if (this.agentsObservable) {
      this.agentsSubscription = this.agentsObservable.subscribe((opts) => this.setAgents(opts));
    }
    if (options['hide']) {
      this.class = 'display-none';
    }
  }

  onDeleteQuestion() {
    super.onDeleteQuestion();
    if (this.agentsSubscription) {
      this.agentsSubscription.unsubscribe();
    }
  }

  setAgents(agents) {
    this.agents = agents || [];
    this.agentsIds = this.agents.filter((agent) => this.value.includes(agent.id)).map((agent) => agent.id);
    super.setOptions({ options: this.parseAgentsToOptions(agents) });
  }

  parseAgentsToOptions(agents) {
    return agents ? agents.map((agent) => ({ key: agent.id, value: this.parseAgent(agent) })) : [];
  }

  parseAgent(agent) {
    const name = `${agent.name ? agent.name : ''} ${agent.surname ? agent.surname : ''}`;
    const nameAndEmail = `${name ? `${name}, ${agent.email}` : agent.email}`;
    const clientName = `${agent.clientName ? ' (' + agent.clientName + ')' : ''}`;
    const role = `${['csm', 'supportSpecialist', 'csAdmin'].includes(agent.role) ? ' (' + agent.role + ')' : ''}`;
    return `${nameAndEmail}${clientName}${role}`;
  }

  getData = (value: string): any => {
    const data = this.agents.find((agent) => agent.id === value);
    return data;
  };

  onChangeAgents(value, parent) {
    this.agentsIds = value;
    const allAgents = new Set(parent.childQuestions.map((child) => child.agentsIds).flat());
    parent.control.setValue([...allAgents]);
  }
}
